const t=async t=>{let e=0;const n=[];for(;;){const{done:o,value:r}=await t.read();if(o)break;n.push(r),e+=r.length}const o=new Uint8Array(e);let r=0;for(const t of n)o.set(t,r),r+=t.length;return o};export{t as readStreamFileFromResponse};
